export enum WX {
  GET_CUR_EXTERNAL_CONTACT = "getCurExternalContact", // 获取当前外部联系人userId
  GET_CRU_EXTERNAL_CHAT = "getCurExternalChat", // 获取当前客户群的群ID
}

export enum ENTRY {
  CONTACT_PROFILE = "contact_profile", // 从联系人详情进入	3.0.24
  SINGLE_CHAT_TOOLS = "single_chat_tools", // 从单聊会话的工具栏进入	3.0.24
  GROUP_CHAT_TOOLS = "group_chat_tools", //	从群聊会话的工具栏进入	3.0.24
  CHAT_ATTACHMENT = "chat_attachment", //	从会话的聊天附件栏进入	3.1.6
  SINGLE_KF_TOOLS = "single_kf_tools", //	从微信客服的工具栏进入	3.1.10
  NORMAL = "normal", // 除以上场景之外进入，例如工作台，聊天会话等
}

export const external = (entry: ENTRY) => {
  if ([ENTRY.SINGLE_CHAT_TOOLS, ENTRY.CONTACT_PROFILE].includes(entry)) return WX.GET_CUR_EXTERNAL_CONTACT;
  else if ([ENTRY.GROUP_CHAT_TOOLS].includes(entry)) return WX.GET_CRU_EXTERNAL_CHAT;
};

/** 是否是群聊进入 */
export const isChat = (entry: ENTRY) => entry == ENTRY.GROUP_CHAT_TOOLS;

/** 是否是可用入口 */
export const isUsable = (entry: ENTRY) => [ENTRY.CONTACT_PROFILE, ENTRY.SINGLE_CHAT_TOOLS, ENTRY.GROUP_CHAT_TOOLS].includes(entry);
